import React from "react";
import { Button } from "reactstrap";
import { Login } from "./Login";
import { useAuth } from "./useAuth";

const centered = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  color: "#575757",
};

// Anyone not signed in gets ADC's sign-in form in place of the app.
export const Protected = ({ children }) => {
  const { isAuthenticated, isLoading, checkError, retry, signOut } = useAuth();

  if (isAuthenticated) return <>{children}</>;

  if (isLoading) return <div style={centered}>Signing you in...</div>;

  // A stored session the server could not check. Not a reason to sign out:
  // it is usually the API or Logto being briefly down.
  if (checkError) {
    return (
      <div style={centered}>
        <div>{checkError}</div>
        <div style={{ display: "flex", gap: "8px" }}>
          <Button size="sm" onClick={retry}>
            Try again
          </Button>
          <Button size="sm" outline onClick={signOut}>
            Sign out
          </Button>
        </div>
      </div>
    );
  }

  return <Login />;
};
